import { parsePhoneNumberFromString } from "libphonenumber-js";
import accounts from "./api/accounts";

export const phoneNumberValidation = val => {
  if(!val) return false;

  const phoneNumber = parsePhoneNumberFromString(val, "GB");
  if (phoneNumber) {
    return phoneNumber.isValid();
  }
  
  return false;
};

export const phoneNumberValidationAllowEmpty = val => {
  if(!val) return true;

  const phoneNumber = parsePhoneNumberFromString(val, "GB");
  if (phoneNumber) {
    return phoneNumber.isValid();
  }
  
  return false;
};
